import { FormDataModel } from '@/model/FormModel'

export const rukuFormField: FormDataModel[] = [
  {
    title: '入库信息',
    type: 1, // 常规表单
    labelClass: 'green',
    labelName: '基',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'list',
        fieldName: '渲染列表',
        config: {},
        id: 0,
        list: [
          {
            componentType: 'el-select',
            componentName: '输入框',
            fieldKey: 'materialId',
            fieldName: '入库材料',
            placeholder: '',
            value: '',
            option: [],
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: true,
              clearable: true,
              url: '',
              filterable: false,
              selectType: 3 // 1本地2远程
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'materialNo',
            fieldName: '物料材料',
            placeholder: '',
            value: '',
            option: [],
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: true,
              clearable: true,
              url: '',
              filterable: false,
              selectType: 3 // 1本地2远程
            }
          }, {
            componentType: 'el-tree',
            componentName: '输入框',
            fieldKey: 'locationId',
            fieldName: '入库位置',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            option: [],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false,
              selectType: 3 // 1本地2远程
            }
          },
          {
            componentType: 'el-tree',
            componentName: '输入框',
            fieldKey: 'oldLocationId',
            fieldName: '原位置',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            option: [],
            config: {
              isDisabled: true,
              clearable: true,
              url: '',
              filterable: false,
              purchaseType: 2,
              selectType: 3 // 1本地2远程
            }
          },
          {
            componentType: 'el-number',
            componentName: '输入框',
            fieldKey: 'amount',
            fieldName: '入库数量',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false,
              type: 'number',
              maxlength: '',
              minlength: 0
            }
          },
          {
            componentType: 'el-number',
            componentName: '输入框',
            fieldKey: 'fee',
            fieldName: '单价',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              purchaseType: 3,
              width: '100%'
            }
          },
          {
            componentType: 'el-textarea',
            componentName: '输入框',
            fieldKey: 'reason',
            fieldName: '原因',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              purchaseType: 3,
              width: '100%'
            }
          }

          // {
          //   componentType: 'el-input',
          //   componentName: '输入框',
          //   fieldKey: 'fee',
          //   fieldName: '单价',
          //   placeholder: '',
          //   value: '',
          //   rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
          //   config: {
          //     isDisabled: false,
          //     clearable: true,
          //     url: '',
          //     filterable: false,
          //     type: 'number'
          //   }
          // }, {
          //   componentType: 'el-input',
          //   componentName: '输入框',
          //   fieldKey: 'tax',
          //   fieldName: '税费,
          //   placeholder:'',
          //   value: '',
          //   rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
          //   config: {
          //     isDisabled: false,
          //     clearable: true,
          //     url: '',
          //     filterable: false,
          //     type: 'number'
          //   }
          // }

        ]
      }
    ]
  }
]
